import ContatoList from './list';

export default function ContatoPage() {
  return <ContatoList />;
}
